import { Alert } from 'mcsclient/models';
import { currentUserCsidQueryParamName } from 'RouteConstants';

const getCsidFromAlert = (alert: Alert) => {
  if (!alert.detailsWebviewUrl) {
    return undefined;
  }

  const { searchParams } = new URL(alert.detailsWebviewUrl);
  return searchParams.get('csid') ?? searchParams.get(currentUserCsidQueryParamName);
};

export { getCsidFromAlert };
